/* eslint-disable max-len */

const TitleWithImage = ({ icon, title, bg = "#fff" }: any) => {
  return (
    <div className="flex items-center gap-[8px]">
      <div
        className="w-[32px] h-[32px] flex justify-center items-center rounded-[16px]"
        style={{ backgroundColor: bg }}
      >
        {icon}
      </div>
      <h5 className="font-['Inter'] text-[14px] text-[rgba(48,47,46,0.6)] font-[600] uppercase">
        {title}
      </h5>
    </div>
  );
};

export default TitleWithImage;
